// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 57) return "static/chunks/57-0bf52fffaa4a0fa1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1006":"afed9d34eb59f7ae","2699":"cdc77629e620f343","8607":"0d8d765b67c4f82f","9656":"0b8885cc03adb6b9"}[chunkId] + ".js";
};